export function normalizeDurationPriceMap(input) {
  const value = typeof input === 'string'
    ? (() => {
        try {
          return JSON.parse(input)
        } catch {
          return null
        }
      })()
    : input

  if (!value || typeof value !== 'object' || Array.isArray(value)) return null

  const normalized = {}
  for (const [rawKey, rawValue] of Object.entries(value)) {
    const minutes = Number.parseInt(String(rawKey || '').trim(), 10)
    const amount = Number(rawValue)
    if (!Number.isInteger(minutes) || minutes <= 0 || !Number.isFinite(amount) || amount < 0) continue
    normalized[String(minutes)] = amount
  }

  return Object.keys(normalized).length ? normalized : null
}

export function deriveConfiguredRacquetDurationOptions({ court } = {}) {
  return normalizeCourtDurations(court).sort((a, b) => a - b)
}

export function deriveBookableRacquetDurationOptions({ configuredDurationOptions, maxAllowedMinutes } = {}) {
  const configured = Array.isArray(configuredDurationOptions) ? configuredDurationOptions : []
  return configured.filter((minutes) => !Number.isFinite(maxAllowedMinutes) || minutes <= maxAllowedMinutes)
}

export function deriveRacquetDurationOptions({ court, maxAllowedMinutes } = {}) {
  return deriveBookableRacquetDurationOptions({
    configuredDurationOptions: deriveConfiguredRacquetDurationOptions({ court }),
    maxAllowedMinutes,
  })
}

export function normalizeCourtDurations(court = {}) {
  const configuredMap = normalizeDurationPriceMap(court?.duration_price_map)
  if (!configuredMap) return []
  return Object.keys(configuredMap)
    .map((value) => Number.parseInt(value, 10))
    .filter((value) => Number.isInteger(value) && value > 0)
}

export function getPreferredRacquetDuration({ requestedDuration, court, durationOptions } = {}) {
  const options = Array.isArray(durationOptions) ? durationOptions : []
  if (!options.length) return null

  const parsedRequested = Number.parseInt(requestedDuration, 10)
  if (Number.isInteger(parsedRequested) && options.includes(parsedRequested)) {
    return parsedRequested
  }

  const defaultDuration = Number.parseInt(court?.default_duration_minutes, 10)
  if (Number.isInteger(defaultDuration) && options.includes(defaultDuration)) {
    return defaultDuration
  }

  return options[0]
}

export function isValidRacquetDurationSelection(durationMinutes, durationOptions = []) {
  const parsed = Number.parseInt(durationMinutes, 10)
  return Number.isInteger(parsed) && durationOptions.includes(parsed)
}
